import * as React from 'react';
import { useSelector } from 'react-redux';

import { Table, TableContainer } from 'components/table';
import Pagination from 'components/pagination/Pagination';
import Spinner from 'components/spinner/Spinner';

import CcmCampaignsTableHead from './head/CcmCampaignsTableHead';
import CcmCampaignsTableRow from './row/CcmCampaignsTableRow';

import './ccm-campaigns-table-by-state.scss';

import type {
  CampaignWithSubcampaignMeta,
  State as GlobalState,
  LocationWindow,
  Pagination as PaginationType
} from 'types';

type Props = {
  campaignsIsLoading: boolean,
  campaignsList: Array<CampaignWithSubcampaignMeta>,
  campaignsPagination?: PaginationType,
  onPageChange: (page: number) => void
};

const CcmCampaignsTableByState: React.FC<Props> = ({
  campaignsIsLoading,
  campaignsList,
  campaignsPagination,
  onPageChange
}): JSX.Element => {
  const location = useSelector((state: GlobalState): LocationWindow => state.router.location);

  const renderSpinner = (): React.ReactNode => (
    <div className="ccm-campaigns-table-by-state__spinner">
      <Spinner
        position="inline"
        size="small"
        color="light"
      />
    </div>
  );

  return (
    <div className="ccm-campaigns-table-by-state">
      <TableContainer>
        <Table style="none">
          <CcmCampaignsTableHead />
          <div className="ccm-campaigns-table-by-state__container">
            {
              (campaignsList || []).map(campaign => (
                <CcmCampaignsTableRow
                  key={`ccm-campaigns-table-by-state__row--${campaign.id}`}
                  campaign={campaign}
                />
              ))
            }
            {
              campaignsIsLoading &&
                renderSpinner()
            }
          </div>
          {
            campaignsPagination && (
              <Pagination
                className="campaigns-table-by-state__pagination"
                location={location}
                meta={campaignsPagination}
                links={campaignsPagination.links}
                scrollToTopOnPageChange={false}
                onClick={onPageChange}
              />
            )
          }
        </Table>
      </TableContainer>
    </div>
  );
};

export default CcmCampaignsTableByState;
